import styled from 'styled-components'
import { media } from '../../../utils'

const Question = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin: 0;
  padding: 15px 5% 30px 5%;
  font-size: 24px;
  font-weight: bold;
  text-align: center;

  &:first-child {
    padding-top: 30px;
  }

  & > p {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 0;
  }

  & > img {
    width: 45px;
    margin: 7.5px;
    ${media.phone` display: none; `}
  }
`

export default Question



// WEBPACK FOOTER //
// ./src/components/atoms/wizard/Question.tsx